import api from "@/utils/axios";

const REPORT_API_URL = `/reports`;

export default {
  namespaced: true,
  state: {
    reports: [],
    meta: {},
    loading: false,
    error: null,
    dashboard: null,
  },
  mutations: {
    SET_REPORTS(state, data) {
      state.reports = data;
    },
    APPEND_REPORTS(state, data) {
      state.reports = [...state.reports, ...data];
    },
    SET_META(state, meta) {
      state.meta = meta;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DASHBOARD_SUMMARY(state, payload) {
      state.dashboard = payload;
    },
    CLEAR_REPORTS(state) {
      state.reports = [];
      state.meta = {};
      state.error = null;
      state.dashboard = null;
    },
  },
  actions: {
    async fetchDashboardSummary({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/dashboard/`, payload);
        commit("SET_DASHBOARD_SUMMARY", res.data.data);
        return res.data.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch dashboard summary`
        );
        commit("SET_DASHBOARD_SUMMARY", null);
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchPaymentReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/payment/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Payment report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchSalesReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/sales/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Sales report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchTaxReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/tax/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Tax report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchDiscountReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/discount/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Discount report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchProductPurchaseReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(
          `${REPORT_API_URL}/product-purchase/`,
          payload
        );
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Product Purchase report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async lazyFetchReports({ commit }, { type, payload = {} }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const endpointMap = {
          sales: "sales",
          tax: "tax",
          discount: "discount",
          payment: "payment",
          "product-purchase": "product-purchase",
        };
        const endpoint = endpointMap[type];
        if (!endpoint) {
          throw new Error(`Unsupported report type: ${type}`);
        }
        const res = await api.post(`${REPORT_API_URL}/${endpoint}/`, payload);
        commit("APPEND_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to load more ${type} report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    clearReports({ commit }) {
      commit("CLEAR_REPORTS");
    },
  },
  getters: {
    reports: (state) => state.reports,
    reportMeta: (state) => state.meta,
    isReportLoading: (state) => state.loading,
    reportError: (state) => state.error,
    dashboardSummary: (state) => state.dashboard,
  },
};
